import React from "react";
const IconPercentage = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M4.5 11.9998L12.5 3.99976"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse cx="5.3" cy="4.79971" rx="1.6" ry="1.6" stroke="currentColor" strokeWidth="2" />
    <ellipse cx="11.7" cy="11.1997" rx="1.6" ry="1.6" stroke="currentColor" strokeWidth="2" />
  </svg>
);
export default IconPercentage;
